import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalObj } from "utils/utility/local-storage";
import { HeaderWrapper, StyledDropdown } from "./styles";
import { getOptions } from "../school-admin-header/helper";
import { Wrapper } from "../school-admin-header/styles";
import { Dropdown } from "react-bootstrap";
import profileIcon from "assets/ntat/icons/profile.svg";
import CustomHeaderIcon from "share/custom-header-icon";
import Logo from "assets/ntat/icons/logo.svg";
import { logoutEmployeeRequest } from "../../../../student/Login/actions";

const dropdownOptions = [
  {
    id: 5,
    icon: CustomHeaderIcon,
    name: "Logout",
    iconName: "logout",
    type: "logout"
  }
];

const NtatHeader = ({ showWelcome = false, ...rest }) => {
  const {
    employeeDetailsReducer: { data }
  } = useSelector((state) => state.studentLogin);
  const dispatch = useDispatch();
  const [employeeName, setEmployeeName] = useState("");
  const [empId, setEmpId] = useState("");

  useEffect(() => {
    (() => {
      try {
        const { first_name, last_name, employee_id } = { ...data };
        if (first_name && last_name) {
          const empName = `${first_name} ${last_name}`;
          setEmployeeName(empName);
        }
        if (employee_id) {
          setEmpId(employee_id);
        }
      } catch (error) {
        setEmployeeName("user");
      }
    })();
  }, [data]);
  const handleDropdown = (type) => {
    if (type === "logout") {
      dispatch(logoutEmployeeRequest());
    }
  };
  return (
    <HeaderWrapper smallHeader={!showWelcome} {...rest}>
      {showWelcome && (
        <div className="welcome-message">
          <span>Welcome,</span>
          <h3>{employeeName}</h3>
        </div>
      )}
      {!showWelcome && (
        <div className="logo-wrapper">
          <img src={Logo} alt="NTAT Logo" />
        </div>
      )}

      <div className="profile-wrapper">
        <div className="profile-data">
          <h3 className="name">{employeeName}</h3>
          <span className="admissiion-id">{empId}</span>
        </div>

        <StyledDropdown
          variant=""
          title={
            <div className="profile-picture-wrapper">
              <img src={profileIcon} alt="profile" />
            </div>
          }
        >
          {dropdownOptions.map((field) => (
            <Dropdown.Item
              onClick={() => handleDropdown(field.type)}
              key={field.id}
            >
              <Wrapper>
                <div className="icon">
                  <field.icon icon={field.iconName} />
                </div>
                <p className="item-name">{field.name}</p>
              </Wrapper>
            </Dropdown.Item>
          ))}
        </StyledDropdown>
      </div>
    </HeaderWrapper>
  );
};

export default NtatHeader;
